import * as action_types from './../api/constants/action-types'

export function switchLanguage(language){
  return {
    type: action_types.SWITCH_LANGUAGE,
    language
  }
}
